import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SkillConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { SkillService } from './api/skill.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SkillApiModule {
    public static forRoot(configurationFactory: () => SkillConfiguration): ModuleWithProviders<SkillApiModule> {
        return {
            ngModule: SkillApiModule,
            providers: [ { provide: SkillConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SkillApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SkillApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
